import React, { useState } from "react";
import Calculators from "../components/Calculators";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../components/Sidebar";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../utils/them";
import Mode from "../components/Mode";

const Calculator = () => {
  const [sidebar, setSidebar] = useState(false);
  return (
    <>
    <ThemeProvider theme={theme}>
      <Container fluid>
        <Row>
          <Sidebar sidebar={sidebar} setSidebar={setSidebar} />
          <Col
            className={
              sidebar
                ? `income-streams-container`
                : `income-streams-container sidebar-collapse`
            }
          >
            <Calculators />
          </Col>
        </Row>
      </Container>
    </ThemeProvider>
    <Mode/>
    </>
  );
};
export default Calculator;
